import React, { PureComponent } from 'react';

export default class OverViewIcon extends PureComponent {

    render() {
        const { color } = this.props
        return (
            <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1zm0 10v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1zM10 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1zm0 10v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1z" fill={color} fill-rule="nonzero"/>
            </svg>
        )
    }
}